export * from './delete-objekt-nutzung-request.interface';
export * from './delete-objekt-nutzung-response.interface';
export * from './delete-objekt-nutzung.shapes';
